import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import { getColumnsContracts } from '../table/getColumns';
import { Table } from '../../../../../components/table';

const defaultSorted = { dataField: 'studentName', order: 'desc' };

function Component(props) {
    const { contracts, onShowModal } = props;

    const columns = useMemo(() => getColumnsContracts(onShowModal), [onShowModal]);

    return (
        <div>
            <Table
                tableName="contracts"
                data={contracts}
                columns={columns}
                defaultSorted={defaultSorted}
                emptyMessage="No contracts were found"
            />
        </div>
    );
}

Component.displayName = 'ContractsTable';

export default connect(null, {

})(Component);